interface ButtonIconProp extends React.HTMLAttributes<HTMLButtonElement> {
  link?: string
  children: React.ReactNode
  badgeValue?: number | string
  badgeColor?: string
  badgeTextColor?: string
  enableHover?: boolean
  padding?: string
  badgeDimensions?: {
    width: string
    height: string
    bottom: string
    left: string
  }
  onClick?: () => void
  setCookie?: () => void
  itemsTotal?: number
}

export function ButtonIcon({
  link,
  badgeValue,
  badgeColor = 'restructure-background-blue',
  badgeTextColor = 'white',
  enableHover = true,
  children,
  onClick,
  setCookie,
  padding,
  badgeDimensions,
  itemsTotal,
  ...rest
}: ButtonIconProp) {
  const handleButtonClick = () => {
    setCookie?.()

    if (link) {
      window.location.href = link
    }
  }

  const handleClick = onClick ?? handleButtonClick

  return (
    <button
      className={`${
        enableHover &&
        'hover:bg-neutral02 hover:rounded-full focus:bg-neutral03 focus:rounded-full'
      }  restructure-small-desktop:w-[48px] restructure-small-desktop:h-[48px] flex items-center justify-center relative ${
        padding ?? 'p-2'
      }`}
      onClick={handleClick}
      {...rest}
    >
      {!!badgeValue && (
        <span
          style={badgeDimensions && { ...badgeDimensions }}
          className={`bg-${badgeColor} text-${badgeTextColor} font-medium absolute left-6 bottom-5 restructure-small-desktop:left-[32px] restructure-small-desktop:bottom-[26px] w-4 h-4 restructure-small-desktop:w-[20px] restructure-small-desktop:h-[20px] pl-[1px] flex items-center justify-center  mobile-overline-medium desktop-overline-medium  rounded-full font-inter text-font-size-2 text-center`}
        >
          {badgeValue}
        </span>
      )}
      {children}
    </button>
  )
}
